import { EuiEmptyPrompt, EuiImage, EuiButton, useEuiTheme } from '@elastic/eui';

import accessDeniedDark from '@/assets/img/accessDenied--dark.png';
import accessDeniedLight from '@/assets/img/accessDenied.png';
import { useConfig } from '@/shared/contexts/config';

const imageAlt = 'Image with rainy elements and a 403 number.';
const pageTitle = 'Access denied';
const bodyText =
  "You don't have access to this page. This can happen if you recently switched between cloud organizations or your permissions have changed.";
const homeButtonText = 'Home';

export const Forbidden = () => {
  const { appUrl } = useConfig();
  const { colorMode } = useEuiTheme();
  const isDarkTheme = colorMode === 'DARK';
  const image = isDarkTheme ? accessDeniedDark : accessDeniedLight;

  return (
    <EuiEmptyPrompt
      color="subdued"
      icon={<EuiImage size="fullWidth" src={image} alt={imageAlt} />}
      title={<h2>{pageTitle}</h2>}
      layout="vertical"
      body={<p>{bodyText}</p>}
      actions={[
        <EuiButton key="goHome" color="primary" fill href={appUrl}>
          {homeButtonText}
        </EuiButton>,
      ]}
    />
  );
};
